// src/components/Footer.jsx
import React from 'react';
import logo from '../assets/EscritaLaranja.png';

const Footer = () => {
  return (
    <footer className="bg-gestor-blue text-white text-sm h-10 px-6 w-full flex justify-between items-center">
      <span>&copy; {new Date().getFullYear()} Desenvolvido por L2 Innovation</span>
      <img
        src={logo}
        alt="L2 Innovation"
        className="max-h-[36px] md:max-h-[48px] lg:max-h-[40px] object-contain opacity-80"
      />
    </footer>
  );
};

export default Footer;
